import React from 'react';
import {Form, Formik, Field} from 'formik';
import {Alert, Button, FormGroup, Input, Label} from 'reactstrap';

import {useUserDispatch, useUserState} from 'contexts/user';
import {submitForm} from 'utils/forms';

import CustomRadioField from '../CustomRadioField';

const {SEGMENTATION_FORM_ID} = process.env;

export default function ({onComplete = () => {}}) {
  const userDispatch = useUserDispatch();
  const {uuid, mcFormReqUUID, registrationId} = useUserState();
  return (
    <>
      <p className="text-center mb-2">One more question:</p>
      <div className="optin-wrap">
        <Formik
          initialValues={{
            bucket: null
          }}
          onSubmit={(values, actions) => {
            if (!values || !values.bucket) {
              return onComplete();
            }
            return submitForm(
              {uuid, registrationId, request_uuid: mcFormReqUUID, bucket: values.bucket},
              SEGMENTATION_FORM_ID
            )
              .then(() => userDispatch({type: 'UPDATE_USER', payload: {bucket: values.bucket}}))
              .then(() => onComplete())
              .catch((e) => {
                actions.setStatus({error: e});
                actions.setSubmitting(false);
              });
          }}
          render={({values, handleSubmit, isSubmitting, isValid, handleReset, status, ...props}) => (
            <Form onSubmit={handleSubmit}>
              {status && status.error && <Alert color="danger">{status.error}</Alert>}
              <FormGroup tag="fieldset" value={values.bucket}>
                <p className="text-center">
                  <strong>What’s your biggest reason for joining this Food For Health Masterclass?</strong>
                </p>
                <FormGroup check>
                  <Label check>
                    <Field name="bucket" value="1" component={CustomRadioField} /> My diet’s not the best — I have some
                    room for improvement.
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Label check>
                    <Field name="bucket" value="2" component={CustomRadioField} /> I eat well — but I want to experience
                    the full benefits of healthy eating.
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Label check>
                    <Field name="bucket" value="3" component={CustomRadioField} /> My diet is excellent — and I’m here
                    to learn even more.
                  </Label>
                </FormGroup>
              </FormGroup>

              <Button
                className="text-uppercase text-h4 text-condensed text-800"
                color="cta"
                type="submit"
                disabled={isSubmitting}
                block
              >
                {isSubmitting ? 'Loading...' : 'Reserve Your Free Spot Now'}
              </Button>
            </Form>
          )}
        />
      </div>
    </>
  );
}
